import React from "react";
import "./band_override.css";
import AccountPicker from "../account_picker";
import RootPicker from "../root_picker";
import { useState, useCallback } from "react";
import { endpoints, post_request } from "../../requests";
import { useAuth0 } from "@auth0/auth0-react";
import DatePicker from "../date_picker";

const BandOverride = ({ accounts, roots }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [band_override_account, set_band_override_account] = useState("");
    const [band_override_root, set_band_override_root] = useState("");
    const [band_override_date, set_band_override_date] = useState(
        new Date().toLocaleDateString("en-CA")
    );
    const [band_upper, set_band_upper] = useState(0.05);
    const [band_lower, set_band_lower] = useState(0.05);
    const [is_btn_enabled, set_is_btn_enabled] = useState(true);
    const [display_message, set_display_message] = useState("");
    const [display_message_clr, set_display_message_clr] = useState("black");

    function band_account_on_change(event) {
        set_display_message("");
        console.log("Account selected: " + event.target.value);
        set_band_override_account(event.target.value);
    }
    function band_root_on_change(event) {
        set_display_message("");
        console.log("Root selected: " + band_override_root);
        set_band_override_root(event.target.value);
    }
    function band_date_on_change(event) {
        set_display_message("");
        console.log("Date selected: " + event.target.value);
        set_band_override_date(event.target.value);
    }

    const post_band_override = useCallback(
        async (date, account, root, upper_threshold, lower_threshold) => {
            const token = await getAccessTokenSilently();
            let body = {
                date,
                account,
                root,
                band: { upper_threshold, lower_threshold },
            };
            console.log(body);
            const response_data = await post_request(
                endpoints.post_band_override,
                token,
                body
            );
            return response_data;
        },
        [getAccessTokenSilently]
    );

    const post_band_overrides = useCallback(async () => {
        console.log("post_band_override");
        set_is_btn_enabled(false);
        set_display_message("");
        if (band_override_account === "" || band_override_root === "") {
            set_display_message("Please select an account, and root option.");
            set_display_message_clr("red");
            set_is_btn_enabled(true);
            return;
        }
        let response_data = await post_band_override(
            band_override_date,
            band_override_account,
            band_override_root,
            band_upper,
            band_lower
        );
        if (response_data.is_success) {
            set_display_message("Band override successful.");
            set_band_override_account("");
            set_band_override_root("");
            set_display_message_clr("green");
        } else {
            set_display_message("Error: " + response_data.error);
            set_display_message_clr("red");
        }

        set_is_btn_enabled(true);
    }, [
        band_override_account,
        band_override_date,
        band_override_root,
        post_band_override,
        band_upper,
        band_lower,
    ]);

    return (
        <div className="band_override">
            <div className="band_override_user_input">
                <div className="band_override_date">
                    <DatePicker
                        date={band_override_date}
                        on_change={band_date_on_change}
                    />
                </div>
                <div className="band_account_picker">
                    <AccountPicker
                        accounts={accounts}
                        on_change={band_account_on_change}
                        include_all_option={false}
                    />
                </div>
                <div className="band_root_picker">
                    <RootPicker
                        roots={roots}
                        on_change={band_root_on_change}
                        include_all_option={false}
                    />
                </div>
            </div>
            <div className="band_upper">
                <label>Band Upper Threshold: </label>
                <input
                    className="band_upper_input"
                    type="number"
                    min="0"
                    max="1"
                    step="0.001"
                    value={band_upper}
                    onChange={(event) => {
                        let value = parseFloat(event.target.value);
                        if (isNaN(value)) value = 0;
                        value = Math.min(Math.max(value, 0), 1);
                        set_band_upper(value);
                    }}
                />
            </div>
            <div className="band_lower">
                <label>Band Lower Threshold: </label>
                <input
                    className="band_lower_input"
                    type="number"
                    min="0"
                    max="1"
                    step="0.001"
                    value={band_lower}
                    onChange={(event) => {
                        let value = parseFloat(event.target.value);
                        if (isNaN(value)) value = 0;
                        value = Math.min(Math.max(value, 0), 1);
                        set_band_lower(value);
                    }}
                />
            </div>
            <div className="band_override_submit">
                <input
                    type="button"
                    value="Override Band"
                    className="band_override_submit_btn ram_button"
                    onClick={post_band_overrides}
                    disabled={!is_btn_enabled}
                />
                <p
                    className="band_override_display_msg"
                    style={{ color: display_message_clr }}
                >
                    {display_message}
                </p>
            </div>
        </div>
    );
};

export default BandOverride;
